/**
 * @fileoverview GET handler for the "/engagement/segments/campaign_sentence/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsCampaignSentenceAppGroupId } from "./constants";
import type { EngagementSegmentsCampaignSentenceAppGroupIdResult } from "./types";

export const getEngagementSegmentsCampaignSentenceAppGroupId = reactQueryFetcherAdapter(
  engagementSegmentsCampaignSentenceAppGroupId,
  (
    signal: AbortSignal,
    appGroupId: string,
    campaignId: string
  ): Promise<EngagementSegmentsCampaignSentenceAppGroupIdResult> => {
    return fetch(
      `/engagement/segments/campaign_sentence/${appGroupId}`,
      "GET",
      { campaign_id: campaignId },
      { signal }
    );
  }
);
